var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { xclass: "w-100 min-h-100 sps sps--abv" } }, [
    _c("div", { staticClass: "topGradient gradient-bo-s1 underHeader" }, [
      _c("div", { staticClass: "bs4_container" }, [
        _c("div", { staticClass: "container-fluid m-20" }, [
          _c("div", { staticClass: "well" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "loading",
            }),
            _vm._v(" "),
            !_vm.customer
              ? _c("div", [_vm._v("Pas de compte ProAbono")])
              : _c("div", [
                  _c("div", [_vm._v("Nom: " + _vm._s(_vm.customer.Name))]),
                  _vm._v(" "),
                  _c("div", [_vm._v("Email: " + _vm._s(_vm.customer.Email))]),
                ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid m-20" }, [
      _vm.hostedHomeUrl
        ? _c("iframe", {
            staticStyle: { width: "100%", height: "1000px" },
            attrs: { src: _vm.hostedHomeUrl.href, frameborder: "0" },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }